import React, { useState, useEffect, Fragment } from "react";
import { Box, Card, Stack, responsiveFontSizes } from "@mui/material";
import { fetchRecepcion } from "verticales/FetchData";
import Tabs from "@mui/material/Tabs";
import MDBox from "components/MDBox";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CardContent from "@mui/material/CardContent";
import AppLoading from "verticales/AppLoading.tsx";
import { Label } from "recharts";
import { Backpack, FileDownload, Mail, Margin, Padding } from "@mui/icons-material";
import { json } from "react-router-dom";
import fetchData from "verticales/FetchData";
import PropTypes from "prop-types"; // Importamos PropTypes
import ConfigClient from "./configClient";

const url = "https://292br7ikz2.execute-api.us-east-1.amazonaws.com/st-fe-recepcion/recepcion/";
const action = "mail";

const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index} style={{ padding: "20px" }}>
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

function DatosMail(props: any) {
  // console.log(props.row.original);
  // console.log(props.row.original.id_mensaje);
  const [infoClient, setInfoClient] = useState({});
  const [Attachment, setAttachment] = useState([]);
  const [blocking, setBlocking] = React.useState(true);
  const [documentUrl, setDocumentUrls] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  const infoMail = async () => {
    // setBlocking(true);
    const client = props.row.original;
    const objClient = client;
    // console.log(objClient);
    if (objClient) {
      setInfoClient(objClient);
    } else {
      console.log("La informacion no existe");
    }
    setBlocking(false);
  };

  useEffect(() => {
    infoMail();
  }, []);

  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <DashboardLayout>
      <MDBox pt={4} pb={3} px={3} display="flex" justifyContent="center">
        <Grid>
          <Card
            sx={{
              width: "100vh",
              maxWidth: "90vw",
              maxHeight: "90vh",
              boxShadow: 3,
              borderRadius: 3,
              mr: 20,
            }}
          >
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={5}
              mt={-3}
              p={2}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="bold" color="white" mt={1}>
                Backup Creator
              </MDTypography>
            </MDBox>
            {blocking ? (
              <AppLoading titleCustom={"Backup Creator"} />
            ) : (
              <Grid
                container
                p={3}
                pl={3}
                pr={5}
                sx={{
                  width: "90vh",
                  maxWidth: "90vh",
                  height: "50vh",
                  maxHeight: "90vh", // Ocupa toda la altura disponible
                  fontSize: "18px",
                }}
              >
                {/* Tabs */}
                <Grid item xs={12}>
                  <Tabs
                    value={tabIndex}
                    onChange={handleChange}
                    textColor="primary"
                    indicatorColor="primary"
                  >
                    <Tab label="Configuracion" />
                    <Tab label="Historial Backups" />
                    <Tab label="Modificacion de Tarea" />
                    <Tab label="Informacion de cliente" />
                  </Tabs>
                </Grid>

                {/* Contenedor de los TabPanels */}
                <Grid item xs={12} sx={{ flexGrow: 1, overflow: "hidden", height: "100vh" }}>
                  <Box sx={{ height: "100%", overflow: "auto", padding: 2 }}>
                    <TabPanel value={tabIndex} index={0}>
                      <ConfigClient row={infoClient} />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={1}>
                      Contenido de la Pestaña 2
                    </TabPanel>
                    <TabPanel value={tabIndex} index={2}>
                      Contenido de la Pestaña 3
                    </TabPanel>
                    <TabPanel value={tabIndex} index={3}>
                      Contenido de la Pestaña 4
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            )}
            {/* <CardContent sx={{ bgcolor: "grey.200", textAlign: "center", p: 2 }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Información detallada de los correos que llegan por recepción
              </Typography>
            </CardContent> */}

            <Stack justifyContent="flex-end" direction="row" sx={{ p: 2 }}>
              <MDButton variant="contained" color="info" onClick={props.handleCloseModal}>
                Aceptar
              </MDButton>
            </Stack>
          </Card>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default DatosMail;
